import { render, staticRenderFns } from "./CustomerFeatures.vue?vue&type=template&id=78506394&scoped=true&"
import script from "./CustomerFeatures.vue?vue&type=script&lang=js&"
export * from "./CustomerFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78506394",
  null
  
)

export default component.exports